module.exports = __webpack_public_path__ + "static/media/mobile-app-promotion-es.81fdf62c.png";